import { Controller } from "react-hook-form";

import { useLocalization } from "@i18n";

import { useAdminStructureOpenPitGeometryFormContext } from "./useAdminStructureOpenPitGeometryFormContext";

export const AdminStructureOpenPitSectorsField = () => {
  const { translate } = useLocalization();
  const { form, canWrite, typePersisted } =
    useAdminStructureOpenPitGeometryFormContext();
  const label = translate("admin.structures.geometry.label.sectors");
  const disabled = !canWrite || !typePersisted;

  return (
    <Controller
      control={form.control}
      name="sectors"
      render={({ field, fieldState }) => (
        <label className="group flex min-w-0 w-full flex-col gap-1">
          <span className="text-label group-aria-invalid:text-error">{label}</span>
          <input
            type="number"
            min={0}
            step={1}
            inputMode="numeric"
            aria-label={label}
            aria-invalid={Boolean(fieldState.error) || undefined}
            disabled={disabled}
            value={field.value === "" ? "" : field.value}
            onChange={(event) => {
              const next = event.target.value;
              field.onChange(next === "" ? "" : Number(next));
            }}
            onBlur={field.onBlur}
            name={field.name}
            ref={field.ref}
            className="h-10 w-full rounded-xl border border-border bg-background px-4 text-sm shadow-sm disabled:opacity-60 aria-invalid:border-error aria-invalid:ring-[3px] aria-invalid:ring-error/20"
          />
          {fieldState.error?.message ? (
            <span className="text-error text-sm">{fieldState.error.message}</span>
          ) : null}
        </label>
      )}
    />
  );
};
